(function() {
  var header = document.querySelector('.header');
  if (!header) return;

  function contentPaddingTop() {
    var headerHeight = header.offsetHeight;
    document.body.style.setProperty("--header-height", headerHeight + "px");
    var headerSpacer = document.querySelector('.header-spacer');
    if (headerSpacer) {
      headerSpacer.style.height = headerHeight + 'px';
    }
    console.log('header height', headerHeight);
  }

  function throttle(callback, limit) {
    var waiting = false;
    var callAfterWaiting = null;
    return function() {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(function() {
          waiting = false;
          if (callAfterWaiting) {
            callAfterWaiting();
            callAfterWaiting = null;
          }
        }, limit);
      } else {
        callAfterWaiting = function() {
          callback.apply(this, arguments);
        };
      }
    };
  }

  window.addEventListener('resize', function() {
    throttle(contentPaddingTop, 5);
  });

  window.addEventListener('load', function() {
    contentPaddingTop();
  });

  header.addEventListener('click', function() {
    setTimeout(function() {
      contentPaddingTop();
    }, 500);
  });

  contentPaddingTop();
})();
